import {CanActivateFn} from '@angular/router';
import {inject, Signal} from '@angular/core';
import {AuthService} from '../services/auth.service';
import {NavigationService} from '../services/navigation.service';
import {User} from 'patja-api';
import {firstValueFrom} from 'rxjs';

export const loggedInGuard: CanActivateFn = async () => {
  const authService: AuthService = inject(AuthService);
  const navigationService: NavigationService = inject(NavigationService);

  if (authService.getStoredToken()) {
    const user: Signal<User | null> = await firstValueFrom(authService.getUser());

    if (user()) {
      return true;
    } else {
      navigationService.goToLogin();
      return false;
    }
  }

  navigationService.goToLogin();
  return false;
};
